import { styled } from '@mui/system';
import { colorPalette } from '../../colorPalette';
export const StyledDiv = styled('div')(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: '16px',
    justifyContent: 'center',
}));
export const Container = styled('div')(() => ({
    width: '100%',
}));
export const titleExtension = {
    margin: '16px 16px 0px 16px',
    color: colorPalette.gray900,
    fontSize: '20px',
    fontWeight: 600,
};
export const descExtension = {
    margin: '8px 16px 0px 16px',
    color: colorPalette.gray900,
    fontSize: '14px',
    fontWeight: 400,
};
export const imgContainer = {
    justifyContent: 'center',
    display: 'flex',
};
export const btnContainer = {
    display: 'flex',
};
